import { IModelType } from '@/types/common.ts';

export { runtimeConfig } from './env';

export const APP_VERSION = Number.parseFloat(
    (import.meta.env.PACKAGE_VERSION as string) || '0.0'
);

const ENV = import.meta.env;
export const ACCOUNT_URL = ENV.VITE_ACCOUNT_URL as string;

export const PATHS = {
    index: '/',
    agents: '/agents',
    agent: {
        builder: '/agent/:flowId/builder'
    },
    projects: '/projects',
    project: '/projects/:projectId',
    versionControl: '/version-control',
    akb: '/akb',
    integrations: '/integrations',
    widgets: '/widgets',
    profile: {
        root: '/profile',
        account: '/profile/account',
        billing: '/profile/billing',
        members: '/profile/members',
        keys: '/profile/keys',
        advanced: '/profile/advanced'
    },
    conversations: '/conversations',
    personas: '/personas',
    attributes: {
        root: '/attributes',
        customer: '/attributes/customer/:group?',
        personas: '/attributes/personas/:personaId?/:group?',
        projects: '/attributes/projects/:projectId?/:group?'
    },
    sessions: '/sessions',
    auth: {
        login: {
            root: '/auth/login',
            callback: '/auth/login/callback'
        }
    },
    talkingHead: '/talking-head/:secretKey',
    newoChat: '/newo-chat/:secretKey',
    workflow: '/workflow',
    vibeBuilder: '/vibe-builder'
};

export const DEFAULT_MODEL: IModelType = {
    model_idn: 'gpt4',
    provider_idn: 'openai'
};

export const RUNNER_TYPES = ['nsl', 'guidance'];

export const STATE_SCOPES = ['user', 'agent', 'flow'];

export const GENERAL_MANAGER_AGENT_NAME = 'GeneralManagerAgent';

export const DATE_FORMAT = {
    FULL_24H: 'yyyy-LL-dd HH:mm:ss',
    SHORT_24H: 'LL/dd HH:mm',
    FULL_12H: 'yyyy-LL-dd hh:mm:ss a',
    FULL_12H_MS: 'yyyy-LL-dd hh:mm:ss.SSS a',
    SHORT_12H: 'LL/dd/yyyy hh:mm a',
    DATE_ONLY: 'yyyy-LL-dd'
};

export const MENU_PORTAL = 'menu-portal';
export const POPOVER_PORTAL = 'popover-portal';
export const TOOLTIP_PORTAL = 'tooltip-portal';
